import { useEffect, useState } from 'react';

type UseToasterOptions = {
    open?: boolean;
    autoClose?: boolean;
    timeClose?: number;
    onClose?: () => void;
};

export const useToaster = ({ open: openProp, autoClose, timeClose, onClose }: UseToasterOptions) => {
    const [open, setOpen] = useState(openProp !== undefined ? openProp : true);

    useEffect(() => {
        if (openProp && !open) {
            setOpen(true);
        }
    }, [openProp, open]);

    useEffect(() => {
        if (!autoClose || !open) return;
        const timeout = setTimeout(() => {
            setOpen(false);
            onClose?.();
        }, timeClose ?? 3000);
        return () => clearTimeout(timeout);
    }, [autoClose, open, timeClose, onClose]);

    const close = () => {
        setOpen(false);
        onClose?.();
    };

    return { open, close };
};
